import Model from 'flarum/common/Model';
export default class SeoMeta extends Model {
  objectType() {
    return this.attribute('objectType');
  }
  objectId() {
    return this.attribute('objectId');
  }
  autoUpdateData() {
    return this.attribute('autoUpdateData');
  }
  title() {
    return this.attribute('title');
  }
  description() {
    return this.attribute('description');
  }
  keywords() {
    return this.attribute('keywords');
  }
  robotsNoindex() {
    return this.attribute('robotsNoindex');
  }
  robotsNofollow() {
    return this.attribute('robotsNofollow');
  }
  robotsNoarchive() {
    return this.attribute('robotsNoarchive');
  }
  robotsNoimageindex() {
    return this.attribute('robotsNoimageindex');
  }
  robotsNosnippet() {
    return this.attribute('robotsNosnippet');
  }
  twitterTitle() {
    return this.attribute('twitterTitle');
  }
  twitterDescription() {
    return this.attribute('twitterDescription');
  }
  twitterImage() {
    return this.attribute('twitterImage');
  }
  twitterImageSource() {
    return this.attribute('twitterImageSource');
  }
  openGraphTitle() {
    return this.attribute('openGraphTitle');
  }
  openGraphDescription() {
    return this.attribute('openGraphDescription');
  }
  openGraphImage() {
    return this.attribute('openGraphImage');
  }
  openGraphImageSource() {
    return this.attribute('openGraphImageSource');
  }
  estimatedReadingTime() {
    return this.attribute('estimatedReadingTime');
  }
  createdAt() {
    return this.attribute('createdAt');
  }
  updatedAt() {
    return this.attribute('updatedAt');
  }
  apiEndpoint() {
    const id = this.id();
    return '/seo_meta' + (id ? '/' + id : '');
  }
}
flarum.reg.add('fof-seo', 'common/Models/SeoMeta', SeoMeta);